import axios from 'axios';
import { UrlApi } from '../../../services/apirest';


export const sucursalLocalApi = {
  obtenerSucursalesLocal: (empresa) => axios.get(`${UrlApi}/envasado_sucursales_mercadolibre/xempresa/${empresa}`),
  // Sucursales
    guardarCajaLocal: (data) => 
    axios.post(`${UrlApi}/envasado_cajas_mercadolibre`, {
      sucursal_id: data.sucursal_id,     // ← ID de la sucursal en tu BD local
      mp_pos_id: data.id,                // ← ID de Mercado Pago
      nombre: data.name,                 // ← Nombre de la caja (cambiar name a nombre)
      external_id: data.external_id,     // ← ID externo
      activo: 1,
      sincronizado: 1,
      usuario: localStorage.getItem("user")
    }),
  
actualizarCajaLocal: (id, data) => {
  // console.log("📤 actualizarCajaLocal - id:", id);
  // console.log("📤 actualizarCajaLocal - data:", data);
  
  // Asegurar que data existe y tiene nombre
  if (!data || !data.nombre) {
    console.error("❌ Error: data o data.nombre es undefined");
    return Promise.reject(new Error("data.nombre es requerido"));
  }
  
  return axios.put(`${UrlApi}/envasado_cajas_mercadolibre/${id}`, {
    nombre: data.nombre,
    usuario: localStorage.getItem("user") || 'system'
  });
},
  
  eliminarSucursalLocal: (id) => 
    axios.delete(`${UrlApi}/envasado_sucursales_mercadolibre/${id}`),
  
  eliminarCajaLocal: (id) => 
    axios.delete(`${UrlApi}/envasado_cajas_mercadolibre/${id}`),
};